import React from 'react';
import './MapLegend.css';

const ALERT_ITEMS = [
  { label: 'Red Flag Warning', color: '#e63946' },
  { label: 'Severe / Tornado', color: '#f59e0b' },
  { label: 'Flood', color: '#3b82f6' },
  { label: 'Heat', color: '#a855f7' },
  { label: 'Other', color: '#6b7280' },
];

const DROUGHT_ITEMS = [
  { label: 'D0 — Abnormally Dry', color: '#ffff00' },
  { label: 'D1 — Moderate Drought', color: '#fcd37f' },
  { label: 'D2 — Severe Drought', color: '#ffaa00' },
  { label: 'D3 — Extreme Drought', color: '#e60000' },
  { label: 'D4 — Exceptional Drought', color: '#730000' },
];

const FIRE_ITEMS = [
  { label: 'Active fire detection (NASA FIRMS)', color: '#ff4500' },
];

const NIFC_ITEMS = [
  { label: 'NIFC fire perimeter', color: '#b91c1c' },
];

const LEGENDS = {
  alerts: { title: 'Active Alerts', items: ALERT_ITEMS },
  drought: { title: 'U.S. Drought Monitor', items: DROUGHT_ITEMS },
  fires: { title: 'Active Fire Detections', items: FIRE_ITEMS },
  nifc: { title: 'NIFC Fire Perimeters', items: NIFC_ITEMS },
};

/**
 * Renders a color legend for the active map overlay.
 */
function MapLegend({ overlay }) {
  const legend = LEGENDS[overlay];
  if (!legend) return null;

  return (
    <div className="map-legend">
      <h4 className="map-legend-title">{legend.title}</h4>
      <ul className="map-legend-list">
        {legend.items.map(({ label, color }) => (
          <li key={label} className="map-legend-item">
            <span
              className="map-legend-swatch"
              style={{ backgroundColor: color }}
              aria-hidden="true"
            />
            <span className="map-legend-label">{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default MapLegend;
